/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-06-01 14:00:12
 */
import layoutView from "@/views/layout/Layout";
import config from "@/configs/pathConfigures";
import redirectorPage from "../../views/notice/redirectorPage.vue";

export default {
  path: config.prefixUrl + "/notice",
  component: layoutView,
  children: [
    {
      name: "noticeRedirector",
      path: "redirect",
      component: redirectorPage,
    },
  ],
};
